import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { giantAnimations } from '../admin-layout/animations';
import { GiantConfigService } from '../admin-layout/services/config-service';
import { Router } from '@angular/router';
import { UserRepository } from 'src/app/repositories/user/UserRepository';
import { GiantSnackBarService } from 'src/app/shared/utils/giant-snack-bar';

import { Login } from 'src/app/models/login.model';

@Component({
    selector: 'forgetpassword',
    templateUrl: 'forgetpassword-component.html',
    styleUrls: ['forgetpassword.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: giantAnimations
})
export class ForgetPasswordComponent implements OnInit {
    forgetpasswordForm: UntypedFormGroup;

    UserModel = new Login();

    navObj : any[]= [{ id: 'pages', title: 'Pages', type: 'group', icon: 'pages', children: [] }];

    constructor(
        private _giantConfigService: GiantConfigService,
        private _formBuilder: UntypedFormBuilder,
        // private _loginRepository: LoginRepository,
        private _router: Router,
        private _userRepository: UserRepository,
        private _giantSnackBarService :GiantSnackBarService
    ) {
        // Configure the layout
        debugger;
        this._giantConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        debugger;
        this.forgetpasswordForm = this._formBuilder.group({
            email: ['', [Validators.required]],            
        });
    }

    VerifyUserEmail(form: any) {
        this.UserModel.Email = form.value.email;
        localStorage.setItem("UserEmail",  form.value.email);
        this._userRepository.VerifyUserEmail(this.UserModel).subscribe((res: any) => {
            debugger;
            if (res._obj.ResponseCode == 1) {
                this._giantSnackBarService.snackbarSuccess(res._obj.ResponseMessage);
                this._router.navigate(['/passwordresetcode'])
              }
              if (res._obj.ResponseCode == 0) {
                this._giantSnackBarService.snackbarError(res._obj.ResponseMessage);
              }            
        });

    }
}
